import * as routes from "../constants/routes"

export default function getJournalGridItems(journalsQueryResult) {
  return (
    journalsQueryResult.edges
      // featuredImage must exist
      .filter((e) => e.node.thumbnailImage.gatsbyImageData)
      .map((e) => ({
        gatsbyImageData: e.node.thumbnailImage.gatsbyImageData,
        title: e.node.title,
        comingSoon: e.node.comingSoon,
        href: routes.journalPost.replace(":slug", e.node.slug),
        titleColor: e.node.titleColor,
      }))
  )
}
